module.exports = __webpack_public_path__ + "static/background-mobile-7d812bd28b857166e8f196a51259c2e6.png";